interface EchangeDonneesFields {
    id?: string;
    idEntiteDistant?: string;
    idEntiteLocal: string;
    entiteType: string;
    domainDistant: string;
}

export class EchangeDonnees implements EchangeDonneesFields {

    id?: string;
    idEntiteDistant?: string;
    idEntiteLocal: string;
    entiteType: string;
    domainDistant: string;

    constructor(echangeDonnees?: EchangeDonneesFields) {
        if (echangeDonnees == null) {
            this.initWithDefaultValues();
            return;
        }

        this.id = echangeDonnees.id;
        this.idEntiteDistant = echangeDonnees.idEntiteDistant;
        this.idEntiteLocal = echangeDonnees.idEntiteLocal;
        this.entiteType = echangeDonnees.entiteType;
        this.domainDistant = echangeDonnees.domainDistant;
    }

    initWithDefaultValues() {
        this.id = null;
        this.idEntiteDistant = '';
        this.idEntiteLocal = '';
        this.entiteType = '';
        this.domainDistant = '';
    }

    // static fromJson(data: any): EchangeDonnees {

    // }

    toJson() {
        return {
            ecd_id: this.id,
            ecd_entite_id_distant: this.idEntiteDistant,
            ecd_entite_id_local: this.idEntiteLocal,
            ecd_entite: this.entiteType,
            ecd_domain_distant: this.domainDistant
        };
    }

}
